export default __webpack_public_path__ + "static/media/Warning.c1ad002b.svg";